import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SubscriptionsUIHelpers";

const SubscriptionsUIContext = createContext();

export function useSubscriptionsUIContext() {
  return useContext(SubscriptionsUIContext);
}

export const SubscriptionsUIConsumer = SubscriptionsUIContext.Consumer;

export function SubscriptionsUIProvider({ subscriptionsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newSubscriptionButtonClick: subscriptionsUIEvents.newSubscriptionButtonClick,
    openEditSubscriptionPage: subscriptionsUIEvents.openEditSubscriptionPage,
    openDeleteSubscriptionDialog: subscriptionsUIEvents.openDeleteSubscriptionDialog,
    openDeleteSubscriptionsDialog: subscriptionsUIEvents.openDeleteSubscriptionsDialog,
    openFetchSubscriptionsDialog: subscriptionsUIEvents.openFetchSubscriptionsDialog,
    openUpdateSubscriptionsStatusDialog:
    subscriptionsUIEvents.openUpdateSubscriptionsStatusDialog,
  };

  return (
    <SubscriptionsUIContext.Provider value={value}>
      {children}
    </SubscriptionsUIContext.Provider>
  );
}
